// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__if3O7","inner":"Form_inner__TjcIH","range":"Form_range__2fIH7","name":"Form_name__3ACxB","actions":"Form_actions__27j0f"};